import { render, staticRenderFns } from "./studentLeaveNew.vue?vue&type=template&id=8a8a9612&scoped=true&"
import script from "./studentLeaveNew.vue?vue&type=script&lang=js&"
export * from "./studentLeaveNew.vue?vue&type=script&lang=js&"
import style0 from "./studentLeaveNew.vue?vue&type=style&index=0&id=8a8a9612&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8a9612",
  null
  
)

export default component.exports